module.exports = __webpack_public_path__ + "media/bootstrap-icons/calculator-fill-ad9e7106.svg";